import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { apiCallsCommercial } from '../../utils/apiCallsCommercial'
import { getUrlParameter, isOdd } from '../../utils/helpers'
import cloneDeep from 'lodash.clonedeep'
import Modal from '../../components/modal/Modal'
import GlobalOverlay from '../../components/global-overlay/GlobalOverlay'
import BreakerDetailsFormContainer from '../../components/config-chassis/commercial/BreakerDetailsFormContainer'
import commonFunctionsService from '../../services/CommonFunctionsService'
import ChassisBoard from '../../components/config-chassis/commercial/ChassisBoard'
import Breaker from '../../components/config-chassis/commercial/Breaker'
import LooseItems from '../../components/config-chassis/commercial/LooseItems'
import BoardDetails from '../project-details/commercial/BoardDetails'
import HeaderLogo from '../../components/header-logo/HeaderLogo'
import HeaderBrandCommercial from '../../components/header-brand-commercial/HeaderBrandCommercial'
import HeaderBrandResidential from '../../components/header-brand-residential/HeaderBrandResidential'
import { Player } from '@lottiefiles/react-lottie-player'
import analyticsDataLayer from '../../services/AnalyticsDataLayer'

const { CONST } = require('../../CONST')

const SAMPLE_BREAKER = {
    "ProjectBoardID": 0,
    "BreakerTypeItemID": 0,
    "ChassisIndex": 0,
    "ChassisPositionIndex": 0,
    "BreakerCircuitLabel": "",
    "Chassis1PercentComplete": 0,
    "Chassis2PercentComplete": 0,
    "BreakerTypeReadOnly": {
        "ItemID": 0,
        "TypeCode": "0",
        "TypeCodeLabel": null,
        "BreakerReference": "0",
        "BreakerReferenceLabel": null,
        "DrawingDesc": "0",
        "DrawingDescLabel": null,
        "PoleCount": 0,
        "PoleCountLabel": "",
        "CurrentRating": 0,
        "CurrentRatingLabel": null,
        "PitchPoleSize": 0
    },
    "ParentBreakerTypeItemID": 0,
    "ParentBreakerCurrentRating": 0,
    "ParentBoardBreakerItemID": 0,
    "BreakerIsParent": false,
    "ItemID": 0,
    "ItemGUID": "",
    "IsDeleted": false
}

class ConfigChassis extends Component {
    constructor(props) {
        super(props)

        this.addBreaker = this.addBreaker.bind(this)
        this.selectChassis = this.selectChassis.bind(this)
        this.updateSelectedMiscParts = this.updateSelectedMiscParts.bind(this)
        this.deleteBreakerFromBoard = this.deleteBreakerFromBoard.bind(this)
        this.updateBrekerChassisNote = this.updateBrekerChassisNote.bind(this)

        this.state = {
            projectID: '',
            boardID: '',
            board: {},
            boardToConfigure: {},
            shouldRedirectToBoard: false,
            project: {},
            boardOptionData: [],
            boardOptions: {},
            miscParts: [],
            chassisOptions: [],
            breakerOptionData: [],
            commercialAllPartsAvailable: [],
            breakerOptions: [],
            userId: 0,
            userData: {},
            favBreakers: [],
            isLoading: true,
            apiError: '',
            isBreakerModalOpen: false,
            activeBreakersTab: 'all', // all, favourites, boardonly (boardonly indicates all breakers added to the board minus favourites)
            isDragAndDropEnabled: true,
            editedBreaker: {
                idInCollection: null,
                isFav: false
            },
            pageInfo: '',
            displayMaxBoardLimitReached: '',
            shouldDisplayLooseOptionPlinthMessage: false,
            isConfiguringBoard: false,
            isSavingLooseItems: false,
            selectedChassisIndex: 1,
            isAddingBreaker: [],
            fillQuoteRequirement: 10,
            hasAlreadyShownEnoughQuoteInfo: false,
            totalLooseItems: 0,
            showDragNDropTutorial: false
        }
    }

    componentDidMount() {
        this.setState({
            projectID: getUrlParameter('projectID'),
            boardID: getUrlParameter('boardID')
        }, () => {
            this.initialize()
        })
    }

    initialize() {
        // Load the API data after mounting so the spinner gets rendered first
        apiCallsCommercial.apiGetProject(this.state.projectID)
            .then(projectData => {
                this.setState({
                    project: projectData,
                    fillQuoteRequirement: projectData.FilledQuoteRequirement ? projectData.FilledQuoteRequirement : 10
                })

                return apiCallsCommercial.apiGetBoard(this.state.projectID, this.state.boardID)
            })
            .then(boardData => {
                this.setState({ board: boardData })

                // Load the breaker options
                return apiCallsCommercial.apiGetBoardOption()
            })
            .then(boardOptionData => {
                this.tempBoardOptionData = boardOptionData
                this.setState({
                    boardOptionData: boardOptionData
                })

                return apiCallsCommercial.apiGetBoardOptionLabels()
            })
            .then(boardOptionLabels => {
                // Once we get the board option labels, we need to alter it, as the chassis 1 / 2 pole counts needs to be dynamically driven via the boardOptionData
                const chassis1PoleCount = []
                const chassis2PoleCount = []

                this.tempBoardOptionData.forEach(board => {
                    const check1Data = chassis1PoleCount.find(check => check.value === board.Chassis1PoleCount)
                    if (!check1Data && board.Chassis1PoleCount) {
                        chassis1PoleCount.push({
                            value: board.Chassis1PoleCount,
                            label: `${board.Chassis1PoleCount}`
                        })
                    }

                    const check2Data = chassis2PoleCount.find(check => check.value === board.Chassis2PoleCount)
                    if (!check2Data && board.Chassis2PoleCount) {
                        chassis2PoleCount.push({
                            value: board.Chassis2PoleCount,
                            label: `${board.Chassis2PoleCount}`
                        })
                    }
                })

                boardOptionLabels.OptionsChassis1PoleCount = chassis1PoleCount.sort((a, b) => { return (a.value > b.value) ? 1 : -1 })
                boardOptionLabels.OptionsChassis2PoleCount = chassis2PoleCount.sort((a, b) => { return (a.value > b.value) ? 1 : -1 })

                // All done, set it to state
                this.setState({
                    boardOptions: boardOptionLabels
                })

                return apiCallsCommercial.apiGetBreakerOptions()
            })
            .then(breakerTypeData => {
                this.tempBreakerTypeData = breakerTypeData
                this.setState({
                    breakerOptionData: breakerTypeData
                })

                // Load the board misc parts after the project has been loaded
                return apiCallsCommercial.apiGetBreakerOptionLabels()
            })
            .then(breakerTypeLabelsData => {
                // Once we get the breaker option labels, we need to alter it, as the chassis 1 / 2 pole counts needs to be
                // dynamically driven via the breakerOptionData
                const breakerCurrentRatings = []
                this.tempBreakerTypeData.forEach(breaker => {
                    const check1Data = breakerCurrentRatings.find(check => check.value === breaker.CurrentRating)
                    if (!check1Data && breaker.CurrentRating) {
                        breakerCurrentRatings.push({
                            value: breaker.CurrentRating,
                            label: `${breaker.CurrentRating}A`
                        })
                    }
                })

                breakerTypeLabelsData.OptionsCurrentRating = breakerCurrentRatings.sort((a, b) => { return (a.value > b.value) ? 1 : -1 })

                this.setState({
                    breakerOptions: breakerTypeLabelsData
                })

                // Load the board misc parts after the project has been loaded
                return apiCallsCommercial.apiGetBoardMiscParts()
            })
            .then(miscData => {
                this.setState({
                    chassisOptions: miscData.FittedOptions,
                    miscParts: miscData.LooseSupplyItems
                }, () => {
                    this.setState({ totalLooseItems: this.getTotalLooseItems() })
                    this.checkLooseOptionPlinthPopup()
                })

                // Load the user settings
                return apiCallsCommercial.apiUserSettings()
            })
            .then(userData => {
                this.setState({
                    userData: userData,
                    userId: userData.UserID,
                    wholesalerBranchID: userData.PreferredWholesaler1ItemID,
                    favBreakers: userData.FavouriteBreakers
                })

                return apiCallsCommercial.apiGetAllParts()
            })
            .then(allParts => {
                this.setState({
                    commercialAllPartsAvailable: allParts,
                    isLoading: false
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    startAddingBreaker() {
        this.setState({
            isBreakerModalOpen: true,
            editedBreaker: {
                idInCollection: null,
                isFav: false
            }
        })
    }

    closeBreakerModal() {
        this.setState({ isBreakerModalOpen: false })
        commonFunctionsService.closeModals()
    }

    // Get the currently editing breaker
    getEditingBreaker() {
        if (!this.state.breakerOptionData || !this.state.editedBreaker.idInCollection) { return null }

        if (this.state.editedBreaker.isFav) {
            return this.state.favBreakers.find(item => item.ItemID === this.state.editedBreaker.idInCollection)
        } else {
            return this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === this.state.editedBreaker.idInCollection)
        }
    }

    getBreaker(breakerID) {
        return this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === breakerID)
    }

    isBreakerFavourite(BreakerTypeItemID, ParentBreakerTypeItemID) {
        if (ParentBreakerTypeItemID) {
            return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID && item.ParentBreakerTypeItemID === ParentBreakerTypeItemID) !== undefined
        } else {
            return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID) !== undefined
        }

    }

    getBreakerFavourite(BreakerTypeItemID, ParentBreakerTypeItemID) {
        if (ParentBreakerTypeItemID) {
            return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID && item.ParentBreakerTypeItemID === ParentBreakerTypeItemID)
        } else {
            return this.state.favBreakers.find(item => item.BreakerTypeItemID === BreakerTypeItemID)
        }
    }

    addBreaker(breakerTypeId, parentBreakerTypeId = 0) {
        this.setState({ isLoading: true })

        apiCallsCommercial.apiSaveBoardBreakerToolbox(this.state.boardID, breakerTypeId, parentBreakerTypeId)
            .then(toolboxBreaker => {
                const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerToolboxCollection)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBreakers.push(toolboxBreaker)
                updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBreakers

                // Show tutorial once 1 breaker is added and only if Drag and Drop is enabled. And remember it, so we don't display it again to the user.
                if (window.localStorage.getItem('hasSeenTutorial') === null && updatedBreakers.length === 1 && this.state.isDragAndDropEnabled) {
                    this.setState({ showDragNDropTutorial: true })
                    window.setTimeout(() => this.setState({ showDragNDropTutorial: false }), 6000)
                    window.localStorage.setItem('hasSeenTutorial', 'true')
                }

                this.setState({ board: updatedBoard }, () => {
                    analyticsDataLayer.addBreaker({
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID.toString(),
                        "configuration_name": this.state.board.Name,
                        "configuration_id": this.state.boardID.toString(),             
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "project_type": 'Commercial',
                        "funnel_step": '1',
                        "funnel_total_steps": '1'
                    })
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => {
                this.closeBreakerModal()
                this.setState({ isLoading: false })
            })
    }

    handleDeletingBreaker(breakerID) {
        const breaker = this.getBreaker(breakerID)
        const isBreakerFavourite = this.isBreakerFavourite(breakerID)

        if (isBreakerFavourite) {
            this.deleteFavBreaker(breakerID, breaker.BreakerTypeItemID, breaker.ParentBreakerTypeItemID)
        } else {
            this.deleteBreaker(breakerID, breaker.BreakerTypeItemID, breaker.ParentBreakerTypeItemID)
        }
    }

    deleteBreaker(breakerID, breakerTypeId, parentBreakerTypeId = 0) {
        this.setState({ isLoading: true })

        apiCallsCommercial.apiSaveBoardBreakerToolbox(this.state.boardID, breakerTypeId, parentBreakerTypeId, breakerID, true)
            .then((deletedBreaker) => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerToolboxCollection.filter(item => item.ItemID !== breakerID)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBreakers

                this.setState({
                    board: updatedBoard,
                    editedBreaker: {
                        idInCollection: null,
                        isFav: false
                    }
                }, () => {
                    analyticsDataLayer.removeFromCart({
                        "currency": 'AUD',
                        "value": deletedBreaker.Price,
                        "project_type": 'Commercial',
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID.toString(),
                        "configuration_name": this.state.board.Name,
                        "configuration_id": this.state.boardID.toString(), 
                        "items": [
                            {
                                "item_id": deletedBreaker.BreakerTypeReadOnly.BreakerReference,
                                "item_name": deletedBreaker.BreakerTypeReadOnly.DrawingDesc, // MCB-10kA-1P-16A
                                "quantity": deletedBreaker?.BreakerTypeReadOnly?.PoleCount ? parseInt(deletedBreaker.BreakerTypeReadOnly.PoleCount) : 0,
                                "item_brand": 'FlexSelect',
                                "item_category": deletedBreaker.Category,
                                "item_variant": '',
                                "price": deletedBreaker.Price
                            }
                        ]
                    })
                })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    handleToggleBreakerFavourite(breakerID, ParentBreakerTypeItemID) {
        const breaker = this.getBreaker(breakerID)
        const favouriteBreaker = this.getBreakerFavourite(breaker.BreakerTypeItemID, ParentBreakerTypeItemID)
        const isBreakerFavourite = this.isBreakerFavourite(breaker.BreakerTypeItemID, ParentBreakerTypeItemID)

        var favouriteBreakerItemID = 0
        if (isBreakerFavourite) {
            favouriteBreakerItemID = favouriteBreaker.ItemID
        }

        this.toggleBreakerFavourite(favouriteBreakerItemID, breaker.BreakerTypeItemID, breaker.ParentBreakerTypeItemID, isBreakerFavourite)
    }

    toggleBreakerFavourite(ItemID, breakerTypeId, parentBreakerTypeId = 0, isBreakerFavourite) {
        this.setState({ isLoading: true })

        var favouriteItemID = 0
        if (isBreakerFavourite) {
            favouriteItemID = ItemID
        }

        apiCallsCommercial.apiSaveFavBreaker(this.state.userID, breakerTypeId, parentBreakerTypeId, favouriteItemID, isBreakerFavourite)
            .then(favBreaker => {
                let updatedBreakers = []
                if (isBreakerFavourite) {
                    updatedBreakers = this.state.favBreakers.filter(item => item.ItemID !== ItemID)
                } else {
                    updatedBreakers = cloneDeep(this.state.favBreakers)
                    updatedBreakers.push(favBreaker)
                }

                this.setState({ favBreakers: updatedBreakers })

                if (!isBreakerFavourite) {
                    let breakerItem = this.state.board.ProjectBoardBreakerToolboxCollection.find(res => res.BreakerTypeItemID === breakerTypeId)
                    analyticsDataLayer.addToFavourites({
                        "currency": 'AUD',
                        "project_type": 'Commercial',
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID.toString(),
                        "configuration_name": this.state.board.Name,
                        "configuration_id": this.state.boardID.toString(),                 
                        "value": breakerItem.Price,
                        "items": [{
                            "item_id": breakerItem.BreakerTypeReadOnly.BreakerReference,
                            "item_name": breakerItem.BreakerTypeReadOnly.DrawingDesc,
                            "item_brand": 'FlexSelect',
                            "item_category": breakerItem.Category,
                            "item_variant": '',
                            "price": breakerItem.Price,
                            "quantity": 1
                        }]
                    })
                } else {
                    analyticsDataLayer.removeFromFavourites({
                        "project_type": 'Commercial',
                        "project_name": this.state.project.Title,
                        "project_id": this.state.projectID.toString(),
                        "item_board_name": this.state.board.Name,
                        "item_board_id": this.state.boardID,
                    })
                }
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
            .then(() => this.setState({ isLoading: false }))
    }

    getCurrentBoardData() {
        return this.state.boardOptionData.find(item => item.ItemID === this.state.board.BoardTypeID)
    }

    // ------------------------------
    // Chassis board functions
    // ------------------------------

    // Get the breakers placed on the currently focused chassis
    getChassisBoardBreakers(chassisIndex = this.state.selectedChassisIndex) {
        if (!this.state.board.ProjectBoardBreakerCollection || !this.state.board.ProjectBoardBreakerCollection.length) { return []; }

        return this.state.board.ProjectBoardBreakerCollection.filter(boardBreaker => {
            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === boardBreaker.BreakerTypeItemID);
            return (breakerObj && boardBreaker.ChassisIndex === chassisIndex && !boardBreaker.BreakerIsParent);
        });
    }

    // Checks if chassis position 2 should be disabled or not
    checkIfIndex2IsDisabled() {
        if (!this.state.board.ProjectBoardFittedOptionCollection || !this.state.board.ProjectBoardFittedOptionCollection.length) {
            return false
        }

        // If Board option 2 or 3 is applied, then then we need to disable board index 2
        const checkOption = this.state.board.ProjectBoardFittedOptionCollection.find(item => item.FittedOptionItemID === 2 || item.FittedOptionItemID === 3)
        return checkOption ? true : false
    }

    getDisabledIndex2ComponentName() {
        if (!this.state.board.ProjectBoardFittedOptionCollection || !this.state.board.ProjectBoardFittedOptionCollection.length) {
            return ''
        }

        const checkOption = this.state.board.ProjectBoardFittedOptionCollection.find(item => item.FittedOptionItemID === 2 || item.FittedOptionItemID === 3)

        if (checkOption === undefined) {
            return ''
        } else {
            return checkOption.FittedOptionReadOnly.TypeDescription
        }
    }

    // Get the number of poles already used up by breakers in a specific chassis
    getConfiguredPoleCount(chassisIndex) {
        let count = 0
        this.state.board.ProjectBoardBreakerCollection.forEach(boardBreaker => {
            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === boardBreaker.BreakerTypeItemID)
            if (breakerObj && boardBreaker.ChassisIndex === chassisIndex && !boardBreaker.BreakerIsParent) {
                count += breakerObj.PoleCount
            }
        })

        // For first chassis we need to check if position 2 is filled with emergency lighting
        if (chassisIndex === 1 && this.checkIfIndex2IsDisabled()) {
            count++
        }

        return count
    }

    getChassisPercentComplete(chassisIndex) {
        const boardData = this.getCurrentBoardData()
        const total = boardData[`Chassis${chassisIndex}PoleCount`]
        let doneCount = this.getConfiguredPoleCount(chassisIndex)
        let notRoundedValue = doneCount / total * 100
        let flooredValue = Math.floor(notRoundedValue)

        if (notRoundedValue - flooredValue > 0.5) {
            return Math.ceil(notRoundedValue)
        } else {
            return flooredValue
        }

    }

    selectChassis(index) {
        this.setState({ selectedChassisIndex: index })
    }

    getUsedCount(breakerObject, parentBreakerTypeId) {
        if (!this.state.board.ProjectBoardBreakerCollection) { return 0 }

        return this.state.board.ProjectBoardBreakerCollection.filter(item => {
            if (parentBreakerTypeId) {
                return item.ParentBreakerTypeItemID === parentBreakerTypeId
            } else {
                return item.BreakerTypeItemID === breakerObject.ItemID
            }
        }).length
    }

    isBreakerDisabled(breakerObject, parentBreakerTypeId) {
        const boardData = this.getCurrentBoardData()

        // Disable the breaker if this is a large breaker and we are looking at a standard board
        if (boardData.ChassisType !== 'Hybrid' && breakerObject.CurrentRating >= 80) {
            return true;
        }

        // Disable the breaker if the board's breaking capacity does not match the breaker's
        const breakCode = breakerObject.TypeCode.split('-');
        if (breakCode.length < 2) {
            // Disable the breaker if it's got a weird typecode that doesnt follow the pattern....
            return true;
        }
        if (breakerObject.TypeCode !== '3PH-VIGI' && !breakCode[1].startsWith(`${this.state.board.BreakingCapacity}`)) {
            // For non-VIGI breakers, if the code does not start with the board's breaking capactity, then it should be disabled
            return true;
        }

        // If the breaker is a VIGI breaker, we need to check the breacking capacity of its parent
        if (breakerObject.TypeCode === '3PH-VIGI') {
            const parentBreaker = this.state.breakerOptionData.find(item => item.ItemID === parentBreakerTypeId);
            const parentBreakCode = parentBreaker.TypeCode.split('-');
            if (parentBreakCode.length < 2) {
                // Disable the breaker if it's got a weird typecode that doesnt follow the pattern....
                return true;
            }
            if (!parentBreakCode[1].startsWith(`${this.state.board.BreakingCapacity}`)) {
                // For non-VIGI breakers, if the code does not start with the board's breaking capactity, then it should be disabled
                return true;
            }
        }

        // All passed, not disabled
        return false;
    }

    // Work out the first available board slot to add the specific breaker and then add the breaker to the board if
    // such a slot is found - this function is triggered when a breaker is triggered to be auto added
    autoAddbreaker(breakerId, BreakerTypeItemID) {
        if (!breakerId || this.state.isAutoAdding) { return; }

        const useBreaker = this.getBreakerDataForPlacing(breakerId, BreakerTypeItemID)
        const boardData = this.getCurrentBoardData()
        const polesNeeded = useBreaker.PoleCount
        const chassisPoles = this.state.selectedChassisIndex === 2 ? boardData.Chassis2PoleCount : boardData.Chassis1PoleCount
        const breakers = this.getChassisBoardBreakers()
        const indexOffset = this.state.selectedChassisIndex === 2 ? boardData.Chassis1PoleCount : 0

        // Work out the check start / max index based on if the breaker is a 27mm pitch breaker or not - return empty array is the wrong breaker is used on the wrong board
        const breakerSize = useBreaker.CurrentRating >= 80 ? 27 : 18
        const largePoleCount = boardData.ChassisType === 'Hybrid' ? boardData.Chassis1PoleCount27mm : 0
        if (breakerSize === 27 && !largePoleCount) { return }

        const checkStartIndex = (breakerSize === 27 ? 1 : (largePoleCount + 1 + indexOffset))
        const checkMaxPoles = breakerSize === 27 ? largePoleCount : (chassisPoles + indexOffset)

        // Add the breaker to the first index it can be fitted in
        for (let i = checkStartIndex; i <= checkMaxPoles; i++) {
            let fitIndex = this.getTriggerIndexForPolesFitAtIndex(polesNeeded, i, breakers, checkMaxPoles, checkStartIndex, largePoleCount)
            if (fitIndex !== -1) {
                this.addBreakerToBoard(fitIndex, useBreaker)
                break;
            }
        }
    }

    // This function works out the "trigger index" - this is the chassis position index number to give to
    // the breaker if the breaker is inserted at the specific slot.
    //
    // For instance, if there are 4 slots free on the board, and we try to insert a breaker that takes up 3
    // poles in the last free slot, then the trigger index will not be on the last free slot, but rather, be
    // the index of the previous slot where the breaker can actually fit.
    getTriggerIndexForPolesFitAtIndex(poles, index, breakers, maxPoles, startedIndex, largePoleCount, backStep = 0) {
        // Fail the check if the index value is not valid or if the method has been stepped back more than its pole counts
        if (index < startedIndex || backStep >= poles) { return -1 }

        const finalIndex = index + ((poles - 1) * 2)

        // Check if the final index exceeds the edge of the board
        if (finalIndex > maxPoles) {
            return this.getTriggerIndexForPolesFitAtIndex(poles, index - 2, breakers, maxPoles, startedIndex, largePoleCount, backStep + 1)
        }

        // Check if all pole spots required is free of breakers
        for (let i = index; i <= finalIndex; i = i + 2) {
            if (this.hasBreakerAtIndex(i, breakers, largePoleCount)) {
                // The current checking slot is covered by another breaker, check if we can fit the breaker a bit higher up
                return this.getTriggerIndexForPolesFitAtIndex(poles, index - 2, breakers, maxPoles, startedIndex, largePoleCount, backStep + 1)
            }
        }

        // All check passed, return true
        // OMFG - if the breaker has 3 or more poles, than its display index on the board is actually offset by 2 .... WHY! GOD! WHY!
        return poles >= 3 ? index + 2 : index
    }

    // This function checks if there is a breaker covering the specific chassis position index
    hasBreakerAtIndex(index, breakers, largePoleCount) {
        // If index is 2 and we looking at chassis 1 then check if the slot is blocked by a fitted option
        if (index === (2 + largePoleCount) && this.state.selectedChassisIndex === 1 && this.checkIfIndex2IsDisabled()) {
            return true
        }

        // No breaker collection, no breaker at index
        if (!breakers.length) {
            return false
        }

        // Check if there is already a breaker on the index
        const check = breakers.find(item => item.ChassisPositionIndex === index && item.ChassisIndex === this.state.selectedChassisIndex)
        if (check) { return true }

        // Check if the index is covered by larger breakers
        const colBreakers = breakers.filter(item => {
            const breakerObj = this.getBreakerDataObj(item.BreakerTypeItemID)
            return (isOdd(item.ChassisPositionIndex) === isOdd(index) && breakerObj.PoleCount >= 3)
        })

        if (!colBreakers.length) { return false }

        let foundBreaker = false
        colBreakers.forEach(item => {
            // OMFG - if the breaker has 3 or more poles, than its display index on the board is actually offset by 2 .... WHY! GOD! WHY!
            const breakerObj = this.getBreakerDataObj(item.BreakerTypeItemID);
            const startIndex = item.ChassisPositionIndex - 2;
            const endIndex = startIndex + ((breakerObj.PoleCount - 1) * 2);

            // Check if the index is covered by a big breaker
            if (startIndex <= index && endIndex >= index) {
                foundBreaker = true
            }
        })

        // Still here... that means no breaker at index
        return foundBreaker
    }

    // Get the breaker data from the breaker type id
    getBreakerDataObj(breakerTypeId) {
        return this.state.breakerOptionData.find(item => item.ItemID === breakerTypeId)
    }

    addBreakerToBoard(positionIndex, breakerData = null) {
        // Ignore the request if we are already adding breaker in this position
        if (this.state.isAddingBreaker.indexOf(positionIndex) !== -1) {
            return
        }

        // Update the state with the breakers position we are adding
        this.setState({
            isAddingBreaker: this.state.isAddingBreaker.concat([positionIndex])
        })

        const selectedBreakerData = breakerData ? breakerData : this.state.selectedBreaker.data

        // Here we are to improve the front-end performance when adding breakers. We don't want to display a loader each time and wait for a second or two
        // What we are going to do is to display a loader only when adding the very first breaker, once we have at least one breaker
        // We can use that as a sample object, reset it wrapping properties and add it immediatly locally, so it can be displayed on the board
        // Once the server response is ready we will override it or remove it if there were any errors

        let sampleBreaker = cloneDeep(SAMPLE_BREAKER)
        const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerCollection)
        const updatedProject = cloneDeep(this.state.project)
        const updatedBoard = cloneDeep(this.state.board)

        sampleBreaker.BreakerTypeReadOnly = selectedBreakerData
        // Reset Item ID, so we can use it as an indicator to disable delete button/drag&drop until the response from the server 
        // And to avoid some issues when user tries to do operations on this breakers before it's properly saved
        sampleBreaker.BreakerTypeItemID = selectedBreakerData.ItemID
        sampleBreaker.ItemID = 0
        sampleBreaker.ChassisIndex = this.state.selectedChassisIndex
        sampleBreaker.ChassisPositionIndex = positionIndex

        updatedBreakers.push(sampleBreaker)

        updatedBoard.ProjectBoardBreakerCollection = updatedBreakers
        this.setState({ project: updatedProject, board: updatedBoard })

        apiCallsCommercial.apiSaveBreakerToChassis(this.state.boardID, selectedBreakerData.BreakerTypeItemID, selectedBreakerData.ParentBreakerTypeItemID, selectedBreakerData.ParentBoardBreakerItemID, this.state.selectedChassisIndex, positionIndex)
            .then(boardBreaker => {
                const existingTemporaryBreakerIndex = this.state.board.ProjectBoardBreakerCollection.findIndex(item => item.ChassisPositionIndex === boardBreaker.ChassisPositionIndex && item.ChassisIndex === this.state.selectedChassisIndex)

                const updatedBreakers = cloneDeep(this.state.board.ProjectBoardBreakerCollection)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)

                updatedBreakers[existingTemporaryBreakerIndex] = boardBreaker

                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                // Server will return the percentages of the board completion even if it is just a breaker return data
                updatedBoard.Chassis1PercentComplete = boardBreaker.Chassis1PercentComplete
                updatedBoard.Chassis2PercentComplete = boardBreaker.Chassis2PercentComplete

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                apiCallsCommercial.apiGetBoard(this.state.projectID, this.state.boardID)
                    .then(boardData => {
                        // Update the board breakers quantity with the existing breakers quantity
                        if (this.state.board.ProjectBoardBreakerToolboxCollection?.length > 0 && boardData.ProjectBoardBreakerToolboxCollection?.length > 0) {
                            boardData.ProjectBoardBreakerToolboxCollection.forEach((item) => {
                                let toolboxBreaker = this.state.board.ProjectBoardBreakerToolboxCollection.find(toolboxItem => toolboxItem.ItemID === item.ItemID)
                                item.quantity = toolboxBreaker.quantity ? toolboxBreaker.quantity : 1
                            })
                        }
                        this.setState({ board: boardData })
                    })

                this.setState({ project: updatedProject, board: updatedBoard }, () => {
                    if (this.isEnoughFilledToGenerateQuote() && !this.state.hasAlreadyShownEnoughQuoteInfo) {
                        this.setState({ pageInfo: 'You can now view a quote for this project!', hasAlreadyShownEnoughQuoteInfo: true })
                        window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)
                    }
                })

                analyticsDataLayer.addToCart({
                    'project_type': 'Commercial',
                    'project_name': this.state.project.Title,
                    'project_id': this.state.projectID.toString(),
                    'item_board_name': this.state.board.Name,
                    'item_board_id': this.state.boardID.toString(),
                    'configuration_name': this.state.board.Name,
                    'configuration_id': this.state.board.ItemID.toString()
                }, {
                    'currency': 'AUD',
                    'value': boardBreaker.Price,
                    'items': [
                        {
                            'item_id': boardBreaker.BreakerTypeReadOnly.BreakerReference,
                            'item_name': boardBreaker.BreakerTypeReadOnly.DrawingDesc, //MCB-10kA-1P-16A
                            'quantity': boardBreaker.BreakerTypeReadOnly.PoleCount,
                            'item_brand': 'FlexSelect',
                            'item_category': boardBreaker.Category,
                            'item_variant': '',
                            'price': boardBreaker.Price
                        }
                    ]
                })

            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)

                // Remove the breaker from the board if there was an error
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers.filter(item => item.ItemID !== 0)
                this.setState({ project: updatedProject, board: updatedBoard })
            })
            .then(() => {
                // Set state to indicate we are done adding
                this.setState({ isAddingBreaker: this.state.isAddingBreaker.filter(item => item !== positionIndex) })
            })
    }

    deleteBreakerFromBoard(positionIndex, boardBreakerId) {
        const selectedBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ItemID === boardBreakerId)

        apiCallsCommercial.apiSaveBreakerToChassis(this.state.boardID, selectedBoardBreaker.BreakerTypeItemID, selectedBoardBreaker.ParentBreakerTypeItemID, selectedBoardBreaker.ParentBoardBreakerItemID, this.state.selectedChassisIndex, positionIndex, boardBreakerId, true)
            .then((boardBreaker) => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerCollection.filter(item => item.ItemID !== boardBreakerId)
                const updatedProject = cloneDeep(this.state.project)
                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                // Server will return the percentages of the board completion even if it is just a breaker return data
                updatedBoard.Chassis1PercentComplete = boardBreaker.Chassis1PercentComplete
                updatedBoard.Chassis2PercentComplete = boardBreaker.Chassis2PercentComplete

                const indexOfTheCurrentProjectBoard = updatedProject.ProjectBoards.findIndex((board) => {
                    return board.ItemID === updatedBoard.ItemID
                })

                updatedProject.ProjectBoards[indexOfTheCurrentProjectBoard] = updatedBoard

                this.setState({ project: updatedProject, board: updatedBoard, pageInfo: 'Breaker deleted' })

                window.setTimeout(() => this.setState({ pageInfo: '' }), 5000)

                analyticsDataLayer.removeFromCart({
                    "currency": 'AUD',
                    "value": selectedBoardBreaker.Price,
                    "project_type": 'Commercial',
                    "project_name": this.state.project.Title,
                    "project_id": this.state.projectID.toString(),
                    "item_board_name": this.state.board.Name,
                    "item_board_id": this.state.boardID.toString(),
                    "configuration_name": this.state.board.Name,
                    "configuration_id": this.state.boardID.toString(),
                    "items": [
                        {
                            "item_id": selectedBoardBreaker.BreakerTypeReadOnly.BreakerReference,
                            "item_name": selectedBoardBreaker.BreakerTypeReadOnly.DrawingDesc, // MCB-10kA-1P-16A
                            "quantity": selectedBoardBreaker?.BreakerTypeReadOnly?.PoleCount ? parseInt(selectedBoardBreaker.BreakerTypeReadOnly.PoleCount) : 0,
                            "item_brand": 'FlexSelect',
                            "item_category": selectedBoardBreaker.Category,
                            "item_variant": '',
                            "price": selectedBoardBreaker.Price
                        }
                    ]
                })

                apiCallsCommercial.apiGetBoard(this.state.projectID, this.state.boardID)
                    .then(boardData => {
                        // Update the board breakers quantity with the existing breakers quantity
                        if (this.state.board.ProjectBoardBreakerToolboxCollection?.length > 0 && boardData.ProjectBoardBreakerToolboxCollection?.length > 0) {
                            boardData.ProjectBoardBreakerToolboxCollection.forEach((item) => {
                                let toolboxBreaker = this.state.board.ProjectBoardBreakerToolboxCollection.find(toolboxItem => toolboxItem.ItemID === item.ItemID)
                                item.quantity = toolboxBreaker.quantity ? toolboxBreaker.quantity : 1
                            })
                        }
                        this.setState({ board: boardData })
                    })
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    updateBrekerChassisNote(positionIndex, note) {
        const noteBoardBreaker = this.state.board.ProjectBoardBreakerCollection.find(boardBreaker => boardBreaker.ChassisPositionIndex === positionIndex && boardBreaker.ChassisIndex === this.state.selectedChassisIndex && !boardBreaker.BreakerIsParent)

        apiCallsCommercial.apiSaveBreakerToChassis(this.state.boardID, noteBoardBreaker.BreakerTypeItemID, noteBoardBreaker.ParentBreakerTypeItemID, noteBoardBreaker.ParentBoardBreakerItemID, this.state.selectedChassisIndex, noteBoardBreaker.ChassisPositionIndex, noteBoardBreaker.ItemID, false, note)
            .then(boardBreaker => {
                const updatedBreakers = this.state.board.ProjectBoardBreakerCollection.map(item => {
                    if (item.ItemID === boardBreaker.ItemID) {
                        return boardBreaker
                    } else {
                        return item
                    }
                })

                const updatedBoard = cloneDeep(this.state.board)
                updatedBoard.ProjectBoardBreakerCollection = updatedBreakers

                this.setState({
                    board: updatedBoard,
                    pageInfo: 'Breaker notes saved'
                })

                window.setTimeout(() => {
                    this.setState({ pageInfo: '' })
                }, 5000)
            })
            .catch(error => {
                this.setState({ apiError: error.message })
                window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            })
    }

    displayError(message) {
        this.setState({ apiError: message })
        window.setTimeout(() => this.setState({ apiError: '' }), 5000)
    }

    handleBreakerDrop(poleIndex, ItemID, BreakerTypeItemID, ParentBreakerTypeItemID) {
        const useBreaker = this.getBreakerDataForPlacing(ItemID, BreakerTypeItemID, ParentBreakerTypeItemID)
        const boardData = this.getCurrentBoardData()
        const polesNeeded = useBreaker.PoleCount
        const chassisPoles = this.state.selectedChassisIndex === 2 ? boardData.Chassis2PoleCount : boardData.Chassis1PoleCount
        const breakers = this.getChassisBoardBreakers()
        const indexOffset = this.state.selectedChassisIndex === 2 ? boardData.Chassis1PoleCount : 0

        // Work out the check start / max index based on if the breaker is a 27mm pitch breaker or not - return empty array is the wrong breaker is used on the wrong board
        const breakerSize = useBreaker.CurrentRating >= 80 ? 27 : 18
        const largePoleCount = boardData.ChassisType === 'Hybrid' ? boardData.Chassis1PoleCount27mm : 0
        if (breakerSize === 27 && !largePoleCount) { return }

        const checkStartIndex = (breakerSize === 27 ? 1 : (largePoleCount + 1 + indexOffset))
        const checkMaxPoles = breakerSize === 27 ? largePoleCount : (chassisPoles + indexOffset)

        // Find the first index the current breaker can be fitted in, and if the dropped index is lower then the first position available
        // it means that it's not allowed to add it there. We do it for drag-n-drop functionality to pass through the same pre existing complex checks
        let fitIndex = null
        for (let i = checkStartIndex; i <= checkMaxPoles; i++) {
            fitIndex = this.getTriggerIndexForPolesFitAtIndex(polesNeeded, i, breakers, checkMaxPoles, checkStartIndex, largePoleCount)
            if (fitIndex !== null && fitIndex !== -1) {
                break
            }
        }

        if (fitIndex !== -1) {
            // As we now BE operates on weird shifting index e.g. position 8 for 2+ pole breakers is saved by passing position = 10 to the server
            // We need real pole index to perform some checks here
            let realPoleIndex = poleIndex
            if (useBreaker.PoleCount > 1) realPoleIndex = realPoleIndex - 2

            // If the breaker size is 18 and wanted position is minor than the first available fit position and the wanted position is
            // inside large pole count (27), then trigger an error, otherwise proceed
            if (breakerSize === 18 && (poleIndex < fitIndex || realPoleIndex <= largePoleCount)) {
                this.displayError('This 18mm pitch breaker can not be added to this position!')
                return
            }

            // If it's a larger breaker and we try to position it outside of the large pole count or inside large pole count, but
            // the size will go over not allowed size then trrigger an error
            if (breakerSize === 27 && (realPoleIndex > largePoleCount || realPoleIndex + polesNeeded > largePoleCount)) {
                this.displayError('This 27mm pitch breaker can not be added to this position!')
                return
            }

            // If nothing went wrong, then save the breaker to the board
            this.addBreakerToBoard(poleIndex, useBreaker)

        } else {
            this.displayError('This circuit breaker can not be added!')
        }
    }

    // select the breaker from the toolbox / fav collection
    getBreakerDataForPlacing(breakerId, BreakerTypeItemID, ParentBreakerTypeItemID) {
        let selectedBreaker = null
        if (this.isBreakerFavourite(BreakerTypeItemID, ParentBreakerTypeItemID)) {
            selectedBreaker = this.getBreakerFavourite(BreakerTypeItemID, ParentBreakerTypeItemID)
        } else {
            selectedBreaker = this.state.board.ProjectBoardBreakerToolboxCollection.find(item => item.ItemID === breakerId)
        }

        const useBreaker = this.state.breakerOptionData.find(item => selectedBreaker ? item.ItemID === selectedBreaker.BreakerTypeItemID : false)

        if (useBreaker) {
            useBreaker['BreakerTypeItemID'] = selectedBreaker.BreakerTypeItemID;
            useBreaker['ParentBreakerTypeItemID'] = selectedBreaker.ParentBreakerTypeItemID;
            useBreaker['ParentBoardBreakerItemID'] = selectedBreaker.ParentBoardBreakerItemID;
        }

        return useBreaker
    }

    // Calculate the remaining poles on a chassis
    getRemainingPoleCount(chassisIndex) {
        const configured = this.getConfiguredPoleCount(chassisIndex)
        const boardData = this.getCurrentBoardData()

        return boardData['Chassis' + chassisIndex + 'PoleCount'] - configured
    }

    updateSelectedMiscParts(selectedParts) {
        let newTotalSelectedParts = 0

        this.setState({ isSavingLooseItems: true, isLooseItemsPanelOpen: false })

        // The options data needs to keep the exisitng options and set the isdeleted flag if it has been unchecked
        const newDataArray = this.state.board.ProjectBoardLooseSupplyItemCollection.map(item => {
            const selectedItem = selectedParts.find(part => part.LooseSupplyItemItemID === item.LooseSupplyItemItemID)

            return {
                LooseSupplyItemItemID: item.LooseSupplyItemItemID,
                ItemID: item.ItemID,
                Quantity: selectedItem ? selectedItem.Quantity : 0,
                IsDeleted: (!selectedItem || selectedItem.Quantity === 0)
            }
        })

        selectedParts.forEach(value => {
            // Add in new option id if its not in the existing board option collections
            const existingOption = newDataArray.find(item => item.LooseSupplyItemItemID === value.LooseSupplyItemItemID)
            if (!existingOption) {
                newDataArray.push({ LooseSupplyItemItemID: value.LooseSupplyItemItemID, Quantity: value.Quantity })
            }
        })

        newDataArray.forEach(value => {
            if (!value.IsDeleted) {
                newTotalSelectedParts += value.Quantity
            }
        })

        this.setState({ totalLooseItems: newTotalSelectedParts })

        apiCallsCommercial.apiSaveBoardMiscParts(this.state.projectID, this.state.boardID, newDataArray)
            .then(boardData => {
                this.setState({ board: boardData }, () => this.checkLooseOptionPlinthPopup())
            })
            .catch(error => alert(error.message))
            .then(() => this.setState({ isSavingLooseItems: false }))
    }

    hasMaxBoardLimitBeenReached() {
        // Function to check if the user has reached max board limit or not
        // App should not let user copy or add boards if they are at the limit.
        // Hardcode the max board limit if its not returned from the API
        const boardLimit = this.state.project.MaxBoardLimit ? this.state.project.MaxBoardLimit : 8
        return (this.state.project.ProjectBoards.length >= boardLimit)
    }

    addNewBoard() {
        this.props.history.push(CONST.PAGES.PROJECT_DETAILS + '?orderID=' + this.state.projectID + '&newBoard=true')
    }

    startConfiguringBoard = (isNew) => {
        if (isNew !== undefined && isNew) {
            if (this.hasMaxBoardLimitBeenReached()) {
                this.setState({ displayMaxBoardLimitReached: true })
            } else {
                this.setState({ isConfiguringBoard: true, boardToConfigure: null, shouldRedirectToBoard: true })
            }
        } else {
            this.setState({ isConfiguringBoard: true, boardToConfigure: this.state.board })
        }
    }

    stopConfiguringBoard = (board) => {
        // TODO: complete redirecting to the new board after it was created, it needs proper debugging
        // if (this.state.shouldRedirectToBoard) {
        //     this.props.history.push(CONST.PAGES.CONFIGURE_CHASSIS + '?projectID=' + this.state.projectID + '&boardID=' + board.ItemID)

        //     this.setState({
        //         projectID: getUrlParameter('projectID'),
        //         boardID: getUrlParameter('boardID')
        //     }, () => {
        //         this.initialize()
        //     })
        // } else {
        this.setState({ isConfiguringBoard: false, boardToConfigure: null })
        commonFunctionsService.closeModals()
        // }
    }

    viewQuote() {
        // If you don't have any boards...
        if (!this.state.project.ProjectBoards || !this.state.project.ProjectBoards.length) {
            this.setState({ apiError: 'Your project needs at least one board filled greater than ' + this.state.fillQuoteRequirement + '% to generate a quote.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }

        // You've got boards but not all of them are filled out to minimum levels...
        let noEnoughFilled = !this.isEnoughFilledToGenerateQuote()
        if (noEnoughFilled) {
            this.setState({ apiError: 'Your project needs all boards filled greater than ' + this.state.fillQuoteRequirement + '% to generate a quote.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }

        // Check if all project boards meet the assembly performance checks, display error only for the first one encountered 
        let projectAssemblyCheck = this.checkProjectAssemblyPerformanceChecks()
        if (projectAssemblyCheck !== true) {
            this.setState({
                apiError: 'Can\'t generate quote. Please check error message on "' + projectAssemblyCheck + '" board.'
            })

            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }


        // If you're a contractor you need a selected wholesaler
        if (this.state.userData.UserIsContractor && (this.state.wholesalerBranchID === 0 || this.state.wholesalerBranchID === -1)) {
            this.setState({ apiError: 'Current user doesn\'t have a preferred wholesalers configured.' })
            window.setTimeout(() => this.setState({ apiError: '' }), 5000)
            return false
        }

        // Finally made it through all the hoops, go to the Quote page.
        let pageLink = ""
        if (this.state.userData.UserIsContractor) {
            pageLink += CONST.PAGES.QUOTE + '?projectID=' + this.state.projectID + '&wholesalerBranchID=' + this.state.wholesalerBranchID
            this.props.history.push(pageLink)
        } else {
            pageLink += CONST.PAGES.QUOTE + '?projectID=' + this.state.projectID
            this.props.history.push(CONST.PAGES.QUOTE + '?projectID=' + this.state.projectID)
        }
        analyticsDataLayer.ctaButtonClick({
            cta_name: "View Quote",
            cta_link: window.location.hostname + pageLink,
            cta_location: "Config board"
        })
    }

    isEnoughFilledToGenerateQuote() {
        let noEnoughFilled = false
        this.state.project.ProjectBoards.map(board => {
            if (board.Chassis1PercentComplete < this.state.fillQuoteRequirement ||
                ((board.BoardTypeReadOnly && board.BoardTypeReadOnly.ChassisCount === 2) && board.Chassis2PercentComplete < this.state.fillQuoteRequirement)) {
                noEnoughFilled = true
                return
            }
        })

        return !noEnoughFilled
    }

    checkLooseOptionPlinthPopup() {
        let anyPlinthLooseOptionsSelected = false

        this.state.board.ProjectBoardLooseSupplyItemCollection.map(item => {
            if (item.IsDeleted === false &&
                (item.LooseSupplyItemReadOnly.BOMReference === 'LBASE2GALBK' || item.LooseSupplyItemReadOnly.BOMReference === 'LBASE3GALIP66')) {
                anyPlinthLooseOptionsSelected = true
            }
        })

        this.setState({ shouldDisplayLooseOptionPlinthMessage: anyPlinthLooseOptionsSelected })
    }

    // Checks if the project meet assably performance requirements. Will return true if valid, otherwise the name of the first board that has an issue
    checkProjectAssemblyPerformanceChecks() {
        let checks = true

        for (let index = 0; index < this.state.project.ProjectBoards.length; index++) {
            let projectBoard = this.state.project.ProjectBoards[index]

            // Assure we get updated data for currently opened board
            if (projectBoard.ItemID === this.state.board.ItemID) {
                projectBoard = this.state.board
            }

            if (!projectBoard.AssemblyPowerLossCheckSuccess || !projectBoard.Chassis1PowerLossCheckSuccess || !projectBoard.Chassis2PowerLossCheckSuccess || projectBoard.LoadFactorStatusColour === 'red') {
                checks = projectBoard.Name
                break
            }
        }

        return checks
    }

    getLooseItemSelectedQty(id) {
        if (!this.state.board.ProjectBoardLooseSupplyItemCollection || !this.state.board.ProjectBoardLooseSupplyItemCollection.length) { return 0 }

        const checkPart = this.state.board.ProjectBoardLooseSupplyItemCollection.find(item => item.LooseSupplyItemItemID === id)
        if (!checkPart) { return 0 }

        return checkPart.Quantity
    }

    getTotalLooseItems() {
        let totalSelectedQuantity = 0
        this.state.miscParts.forEach(opt => {
            totalSelectedQuantity = totalSelectedQuantity + this.getLooseItemSelectedQty(opt.ItemID)
        })

        return totalSelectedQuantity
    }

    handleUpdateQuantity(qty, id) {
        const updatedBoard = this.state.board
        updatedBoard.ProjectBoardBreakerToolboxCollection = updatedBoard.ProjectBoardBreakerToolboxCollection.map(item => {
            if (item.ItemID === id) {
                item.quantity = qty
            }
            return item
        })

        this.setState({ board: updatedBoard })
    }

    render() {
        const breaker = this.state.board.ProjectBoardBreakerCollection?.filter(item => item.ItemID).length

        if (this.state.isLoading) {
            return (
                <GlobalOverlay>
                    <div>
                        <div className="globalOverlay__message">
                            <span className="globalOverlay__message-spinner">
                                <span className="spinner"></span>
                            </span>
                            <span className="h3">Loading</span>
                        </div>
                    </div>
                </GlobalOverlay>
            )
        }

        // Display loading only when adding the first breaker
        if (this.state.isAddingBreaker.length > 0 && breaker === 0) {
            return (
                <GlobalOverlay>
                    <div>
                        <div className="globalOverlay__message">
                            <span className="globalOverlay__message-spinner">
                                <span className="spinner"></span>
                            </span>
                            <span className="h3">Adding Breaker</span>
                        </div>
                    </div>
                </GlobalOverlay>
            )
        }

        const boardData = this.getCurrentBoardData()
        const editingFav = this.state.editedBreaker.isFav
        const assemblyPowerLossePercentage = this.state.board.MaxAssemblyPowerLoss > 0 ? (this.state.board.TotalAssemblyPowerLoss * 100 / this.state.board.MaxAssemblyPowerLoss) : 0
        const assemblyCurrentPercentage = this.state.board.MaxCurrent > 0 ? (this.state.board.TotalCurrent * 100 / this.state.board.MaxCurrent) : 0

        return (
            <div className="app">
                {
                    this.state.showDragNDropTutorial &&
                    <GlobalOverlay>
                        <Player autoplay src="https://assets6.lottiefiles.com/packages/lf20_krirt85t.json"></Player>
                    </GlobalOverlay>
                }

                {
                    this.state.isBreakerModalOpen &&
                    <Modal
                        modalClassName=""
                        modalTitle={this.getEditingBreaker() ? 'Edit Breaker' : 'Add Breaker'}
                        callback={() => this.closeBreakerModal()}>

                        <BreakerDetailsFormContainer
                            breaker={this.getEditingBreaker()}
                            breakerOptions={this.state.breakerOptions}
                            breakerOptionData={this.state.breakerOptionData}
                            // isLoading={this.state.isLoading.form}
                            commercialAllPartsAvailable={this.state.commercialAllPartsAvailable}
                            isHybridBoard={editingFav ? true : boardData.ChassisType === 'Hybrid'}
                            isFav={editingFav}
                            breakingCapacity={this.state.board.BreakingCapacity}
                            createCallback={this.addBreaker}
                            updateCallback={editingFav ? this.editFavBreaker : this.editBreaker}
                        />
                    </Modal>
                }

                <div className="app__header">
                    <header className="header">
                        <div className="header__section hs_switchboard">
                            <div className="header__bar">
                                <div className="header-logo-container">
                                    <HeaderLogo />
                                    <span className="divider"></span>
                                    {this.props.isCommercial ? <HeaderBrandCommercial /> : <HeaderBrandResidential />}
                                </div>
                                <h2 className="h5 header__title">Chassis Configuration</h2>
                                <h2 className="h5 header__title">{this.state.board.Name}</h2>

                                <button className="button button--3 button-edit" onClick={() => this.startConfiguringBoard()}>
                                    <span className="button__icon">
                                        <span className="i-edit"></span>
                                    </span>
                                    <span className="button__text">
                                        Edit Board
                                    </span>
                                </button>
                            </div>

                            <div className="header__actions">
                                <button className={'button button--2' +
                                    (!this.isEnoughFilledToGenerateQuote() || this.checkProjectAssemblyPerformanceChecks() !== true ? ' disabled' : '' +
                                        (this.state.isAddingBreaker.length > 0 ? ' is-loading' : ''))}
                                    onClick={() => this.viewQuote()}>
                                    <span className="button__loader"></span>
                                    <span className="button__icon">
                                        <span className="i-document"></span>
                                    </span>
                                    <span className="button__text">
                                        View Quote
                                    </span>
                                </button>

                                <button className="button button--outline button-add" onClick={() => this.addNewBoard()}>
                                    <span className="button__icon">
                                        <span className="i-plus"></span>
                                    </span>
                                    <span className="button__text">
                                        <span className="button__text-lg">Add &nbsp;</span>Board
                                    </span>
                                </button>

                                <Link className="button button--outline button-close" to={CONST.PAGES.PROJECT_DETAILS + '?orderID=' + this.state.projectID}>
                                    <span className="button__icon">
                                        <span className="i-close"></span>
                                    </span>
                                    <span className="button__text">
                                        <span className="button__text-lg">Close &nbsp;</span>Board
                                    </span>
                                </Link>
                            </div>
                        </div>

                    </header>
                </div>

                <div className="app__body">
                    <div className="board__sidebar">
                        <div className="breadcrumbs">
                            <Link className="breadcrumb" to="/">My Commercial Projects</Link>
                            <Link className="breadcrumb" to={CONST.PAGES.PROJECT_DETAILS + '?orderID=' + this.state.projectID}>{this.state.project.Title}</Link>
                            <span className="breadcrumb">{this.state.board.Name}</span>
                        </div>

                        {/* <!-- Sidebar Header --> */}
                        <div className="sidebar__header">
                            <h2 className="sidebar__title h3">My Library</h2>
                            <button className="button button--1" onClick={() => { this.startAddingBreaker() }}>
                                <span className="button__icon">
                                    <span className="i-plus"></span>
                                </span>
                                <span className="button__text">
                                    Add Breaker
                                </span>
                            </button>
                        </div>

                        <div className="tabs tabs--sidebar">
                            <div className={'tab' + (this.state.activeBreakersTab === 'all' ? ' is-active' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'all' })}>
                                <div className="tab__text">
                                    All
                                </div>
                            </div>
                            <div className={'tab' + (this.state.activeBreakersTab === 'favourites' ? ' is-active' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'favourites' })}>
                                <span className="i-favourite"></span>
                                <div className="tab__text">
                                    Favourites
                                </div>
                            </div>
                            <div className={'tab' + (this.state.activeBreakersTab === 'boardonly' ? ' is-active ' : '')}
                                onClick={() => this.setState({ activeBreakersTab: 'boardonly' })}>
                                <span className="i-switchboard"></span>
                                <div className="tab__text">
                                    This board only
                                </div>
                            </div>
                        </div>

                        {/* <!-- Sidebar Body --> */}
                        <div className={'sidebar__body' + (this.state.isDragAndDropEnabled ? ' is-drag-drop' : ' is-auto-placement')}>
                            {this.state.board.ProjectBoardBreakerToolboxCollection.length === 0 &&
                                <div className="board-message-mute">
                                    <svg width="38" height="64" viewBox="0 0 38 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M36.0326 46.66L36.0029 46.7221L35.982 46.7876C35.9142 47.0005 35.7386 47.1712 35.5703 47.2298L35.5114 47.2504L35.4556 47.278L33.9424 48.0277L33.3863 48.3032V48.9237V58.5026V58.5889L33.4011 58.6739C33.4851 59.1568 33.1681 59.5462 32.8607 59.5998L32.8396 59.6035L32.8187 59.608L17.3149 63H17.1045C17.0403 63 16.9536 62.9856 16.8563 62.9516C16.8263 62.9412 16.7982 62.9299 16.7726 62.9185C16.6937 62.8357 16.6093 62.7739 16.5309 62.7287L1.75428 49.8361L1.74648 49.8293L1.73855 49.8227C1.57654 49.6871 1.45972 49.4727 1.45972 49.1736V5.19428C1.45972 5.06099 1.49986 4.92751 1.57152 4.81041C1.6456 4.68935 1.73575 4.6143 1.79916 4.58114L1.94489 4.50493L1.99842 4.44895C2.00967 4.445 2.0219 4.44069 2.03246 4.43689C2.05841 4.42756 2.09145 4.41536 2.12931 4.3998L17.7102 1.00829C17.8259 0.984928 17.9864 1.00564 18.1352 1.13017L18.1714 1.16043L18.2102 1.18715L32.864 11.2658L32.9137 11.3L32.9517 11.3198C32.9578 11.3246 32.9719 11.3358 32.9945 11.3565C33.045 11.4028 33.1011 11.4609 33.1857 11.5494L33.9085 10.8583L33.1857 11.5494C33.3184 11.6881 33.3818 11.7968 33.4109 11.8813C33.4359 11.954 33.4512 12.0516 33.4137 12.2084L33.3863 12.323V12.4409V22.5195V22.8167L33.5486 23.0656L35.9012 26.6743C36.0623 27.0156 36.0941 27.1244 36.0941 27.184V46.4249C36.0941 46.447 36.09 46.4858 36.0767 46.537C36.0635 46.5875 36.0461 46.6318 36.0326 46.66ZM3.67491 5.63244L2.88424 5.8017V6.61029V48.424V48.8789L3.2272 49.1778L14.6954 59.1731L16.3524 60.6174V58.4193V51.1727C16.3524 50.9287 16.4983 50.653 16.7933 50.4656L18.4263 49.6523L18.9805 49.3763V48.7572V31.0988V30.8043L18.8209 30.5569L16.5464 27.0295C16.3843 26.6864 16.3524 26.5772 16.3524 26.5176V15.4395C16.3524 15.1604 16.4541 14.9551 16.5993 14.8187C16.6912 14.7611 16.7946 14.7194 16.9778 14.6548L28.5438 12.1691L30.8022 11.6838L28.9028 10.3692L18.0718 2.87273L17.7162 2.62662L17.2933 2.71714L3.67491 5.63244ZM32.0415 13.0327L30.8291 13.2962L18.5645 15.9616L17.7769 16.1328V16.9388V25.9345V26.2189L17.9265 26.4607L19.6786 29.2927L20.0522 29.8965L20.7454 29.7429L32.771 27.0774L34.1658 26.7683L33.3979 25.5636L32.1599 23.6215C32.0748 23.4286 32.0415 23.2578 32.0415 23.1025V14.2734V13.0327ZM33.882 45.9861L34.6696 45.8149V45.0089V29.5162V28.2755L33.4572 28.539L21.1927 31.2044L20.405 31.3756V32.1816V47.6743V48.915L21.6174 48.6515L33.882 45.9861ZM31.2538 58.3969L32.0415 58.2258V57.4198V49.1736V47.928L30.8253 48.1973L19.9146 50.6128L19.7972 50.6388L19.6892 50.6919L18.3353 51.3583L17.7769 51.6331V52.2555V60.0852V61.3258L18.9893 61.0624L31.2538 58.3969Z" fill="#CBCBCB" stroke="#F3F2F2" strokeWidth="2" />
                                    </svg>
                                    <p>
                                        You don’t have any breakers in your library yet.
                                    </p>
                                    <p>
                                        <strong>Add your first breaker above</strong>
                                    </p>
                                </div>
                            }

                            {/* Render Breakers */}
                            {this.state.board.ProjectBoardBreakerToolboxCollection.length > 0 &&
                                <div className="breakers" style={{ overflow: "hidden", clear: "both" }}>
                                    {this.state.board.ProjectBoardBreakerToolboxCollection.map((toolboxItem, index) => {
                                        toolboxItem.quantity = toolboxItem.quantity === undefined ? 1 : toolboxItem.quantity
                                        if (this.state.activeBreakersTab === 'all' ||
                                            (this.state.activeBreakersTab === 'favourites' && this.isBreakerFavourite(toolboxItem.BreakerTypeItemID, toolboxItem.ParentBreakerTypeItemID)) ||
                                            (this.state.activeBreakersTab === 'boardonly' && !this.isBreakerFavourite(toolboxItem.BreakerTypeItemID))) {

                                            const breakerObj = this.state.breakerOptionData.find(dataItem => dataItem.ItemID === toolboxItem.BreakerTypeItemID)
                                            const displayCode = toolboxItem.ParentBreakerCurrentRating ? `${breakerObj.DrawingDesc}-${toolboxItem.ParentBreakerCurrentRating}A` : breakerObj.DrawingDesc

                                            const availabilityDataForSelectedBreaker = this.state.commercialAllPartsAvailable.find(item => item.ItemCode === breakerObj.BreakerReference)
                                            let validationMessage = ''
                                            if (!availabilityDataForSelectedBreaker.IsInStock) {
                                                validationMessage = `${breakerObj.DrawingDesc} is out of stock. Please, contact <a href="mailto:au.estimating@se.com">au.estimating@se.com</a>`
                                            } else if (availabilityDataForSelectedBreaker.IsLowStock) {
                                                validationMessage = 'Low stock, longer lead times may apply'
                                            } else {
                                                validationMessage = ''
                                            }

                                            return (
                                                <>
                                                    <Breaker
                                                        key={index}
                                                        ItemID={toolboxItem.ItemID}
                                                        BreakerTypeItemID={toolboxItem.BreakerTypeItemID}
                                                        ParentBreakerTypeItemID={toolboxItem.ParentBreakerTypeItemID}
                                                        poleCount={breakerObj.PoleCount}
                                                        drawingDesc={displayCode}
                                                        isDragAndDropEnabled={this.state.isDragAndDropEnabled}
                                                        handleDeletingBreaker={(itemID) => { this.handleDeletingBreaker(itemID) }}
                                                        isBreakerFavourite={this.isBreakerFavourite(toolboxItem.BreakerTypeItemID, toolboxItem.ParentBreakerTypeItemID)}
                                                        quantity={toolboxItem.quantity}
                                                        handleToggleBreakerFavourite={(itemID, ParentBreakerTypeItemID) => { this.handleToggleBreakerFavourite(itemID, ParentBreakerTypeItemID) }}
                                                        usedCount={this.getUsedCount(breakerObj, toolboxItem.ParentBreakerTypeItemID)}
                                                        isDisabled={this.isBreakerDisabled(breakerObj, toolboxItem.ParentBreakerTypeItemID)}
                                                        handleBreakerAutoAdd={(itemID, quantity) => { 
                                                            quantity = parseInt(quantity)
                                                            for (let i = 0; i < quantity; i++) {
                                                                setTimeout(() => {
                                                                    this.autoAddbreaker(itemID, toolboxItem.BreakerTypeItemID) 
                                                                }, 0)
                                                            }
                                                        }}
                                                        addBreakerToBoard={(poleIndex, ItemID, BreakerTypeItemID, ParentBreakerTypeItemID) => {
                                                            this.handleBreakerDrop(poleIndex, ItemID, BreakerTypeItemID, ParentBreakerTypeItemID)
                                                        }}
                                                        handleUpdateQuantity={(quantity, itemID) => { this.handleUpdateQuantity(quantity, itemID) }}
                                                    />
                                                    {validationMessage &&
                                                        <div className="modal__validation-msg">
                                                            <span className="alert__icon">
                                                                <span className="i-exclamation"></span>
                                                            </span>
                                                            <span dangerouslySetInnerHTML={{ __html: validationMessage }}></span>
                                                        </div>
                                                    }
                                                </>
                                            )
                                        } else {
                                            return ''
                                        }
                                    })}
                                </div>
                            }

                        </div>

                        {/* <!-- Sidebar Footer --> */}
                        <div className="sidebar__footer">
                            <div className="sidebar__footer-inner">
                                <div className="sidebar__actions">
                                    <label className="switch">
                                        <input type="checkbox" className="switch__input" checked={!this.state.isDragAndDropEnabled}
                                            onChange={() => this.setState({ isDragAndDropEnabled: !this.state.isDragAndDropEnabled })} />

                                        <div className="switch__button switch__button--on">
                                            <span className="switch__button-icon">
                                                <span className="i-drag"></span>
                                            </span>
                                            <span className="switch__button-text">Drag and Drop</span>
                                        </div>
                                        <span className="switch__slider slider round"></span>
                                        <div className="switch__button switch__button--off">
                                            <span className="switch__button-icon">
                                                <span className="i-plus"></span>
                                            </span>
                                            <span className="switch__button-text">Auto Placement</span>
                                        </div>
                                    </label>
                                </div>

                                <div className="sidebar__footer-bottom">
                                    <h5 className="h4 sidebar__footer-bottom__title">
                                        Loose Items
                                        <span className="sidebar__footer-bottom__title-count">{this.state.totalLooseItems}</span>
                                    </h5>
                                    <button className="button button--outline" disabled={this.state.isSavingLooseItems}
                                        onClick={() => { this.setState({ isLooseItemsPanelOpen: true }); }}>
                                        <span className="button__icon">
                                            <span className="i-plus"></span>
                                        </span>
                                        <span className="button__text">
                                            Select Items
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="board-column">
                        <div className={'power-loss-header' + (this.state.board.MaxThermalLossesDescription !== null ? ' power-loss-header--loading-factor' : '') + (this.state.board.LoadFactorStatusColour === "orange" || this.state.board.LoadFactorStatusColour === "red" ? ' power-loss-header--loading-factor-extended' : '') + (this.state.isAddingBreaker.length > 0 ? ' is-recalculating' : '')}>
                            <h2 className="p">Assembly Performance</h2>
                            <div className="power-loss-header__layout">
                                <div className={'power-loss' + (assemblyPowerLossePercentage > 100 ? ' is-error' : '')}>
                                    <div className="power-loss__text">
                                        <span className="power-loss-icon i-lightning-bolt"></span>
                                        <span className="">{assemblyPowerLossePercentage.toFixed(2)}% Max. Thermal Losses</span>
                                    </div>
                                    <div className="power-loss__meter">
                                        <span className="power-loss__meter-amount" style={{ width: assemblyPowerLossePercentage + '%' }}></span>
                                    </div>
                                </div>

                                <div className={'power-loss' + (assemblyCurrentPercentage > 100 ? ' is-error' : '')}>
                                    <div className="power-loss__text">
                                        <span className="power-loss-icon i-lightning-bolt"></span>
                                        <span className="">{assemblyCurrentPercentage.toFixed(2)}% Max. Current</span>
                                    </div>
                                    <div className="power-loss__meter">
                                        <span className="power-loss__meter-amount" style={{ width: assemblyCurrentPercentage + '%' }}></span>
                                    </div>
                                </div>
                            </div>

                            <div className="power-loss-header__layout power-loss-header__layout--loading-factor">
                                <div className="power-loss loading-factor-text">
                                    <div>
                                        {
                                            this.state.board.MaxThermalLossesDescription !== null &&
                                            <div>{this.state.board.MaxThermalLossesDescription}</div>
                                        }
                                    </div>
                                </div>

                                <div className="power-loss loading-factor-text">
                                    Based on maximum loading at the tee-offs
                                </div>
                            </div>

                            <div className="power-loss-header__layout power-loss-header__layout--loading-factor">
                                {
                                    this.state.board.LoadFactorDescription !== '' && this.state.board.LoadFactorStatusColour === "red" &&
                                    <p className="alert alert--error">
                                        <span className="alert__icon">
                                            <span className="i-exclamation"></span>
                                        </span>
                                        <span className="alert__text">
                                            {this.state.board.LoadFactorDescription}
                                        </span>
                                    </p>
                                }

                                {
                                    this.state.board.LoadFactorDescription !== '' && this.state.board.LoadFactorStatusColour === "orange" &&
                                    <p className="alert alert--warning">
                                        <span className="alert__icon">
                                            <span className="i-exclamation"></span>
                                        </span>
                                        <span className="alert__text">
                                            {this.state.board.LoadFactorDescription}
                                        </span>
                                    </p>
                                }
                            </div>
                        </div>

                        <div className="board__container">
                            <div className="alert-container">
                                {
                                    this.state.pageInfo !== '' &&
                                    <p className="alert alert--success">
                                        <span className="alert__icon">
                                            <span className="i-check-circle"></span>
                                        </span>
                                        <span className="alert__text">
                                            {this.state.pageInfo}
                                        </span>
                                    </p>
                                }

                                {
                                    this.state.apiError !== '' &&
                                    <p className="alert alert--error">
                                        <span className="alert__icon">
                                            <span className="i-exclamation"></span>
                                        </span>
                                        <span className="alert__text">
                                            {this.state.apiError}
                                        </span>
                                    </p>
                                }

                                {
                                    this.state.displayMaxBoardLimitReached &&
                                    <p className="alert alert--error">
                                        <span className="alert__icon">
                                            <span className="i-exclamation"></span>
                                        </span>
                                        <span className="alert__text">
                                            You have reached the maximum number of boards per project and cannot ADD or COPY anymore.
                                        </span>
                                    </p>
                                }

                                {/* {
                                this.state.shouldDisplayLooseOptionPlinthMessage &&
                                <p className="alert alert--warning">
                                    <span className="alert__icon">
                                        <span className="i-exclamation"></span>
                                    </span>
                                    <span className="alert__text">
                                        Bottom gland plate will be fitted inside the board and not removable.
                                    </span>
                                </p>
                            } */}
                            </div>

                            <div className={'board__container-scroll' + (this.state.isDragAndDropEnabled ? ' drag-n-drop' : ' auto-placement')}>
                                <div className="board-width">

                                    <ChassisBoard
                                        breakers={this.getChassisBoardBreakers()}
                                        breakerData={this.state.breakerOptionData}
                                        indexOffset={this.state.selectedChassisIndex === 2 ? boardData.Chassis1PoleCount : 0}
                                        poles={this.state.selectedChassisIndex === 2 ? boardData.Chassis2PoleCount : boardData.Chassis1PoleCount}
                                        hybridPoleCount={boardData.Chassis1PoleCount27mm}
                                        notes={this.state.board.ChassisNotes}
                                        disabledIndex2={this.checkIfIndex2IsDisabled()}
                                        disabledIndex2ComponentName={this.getDisabledIndex2ComponentName()}
                                        deleteCallback={this.deleteBreakerFromBoard}
                                        updateBrekerChassisNote={this.updateBrekerChassisNote}
                                        updateNotesCallback={this.updateChassisNotesOnBoard}
                                        chassis1filled={this.getChassisPercentComplete(1)}
                                        chassis2filled={boardData.ChassisCount === 2 ? this.getChassisPercentComplete(2) : null}
                                        selectedIndex={this.state.selectedChassisIndex}
                                        selectedCallback={this.selectChassis}
                                        total={this.state.selectedChassisIndex === 2 ? boardData.Chassis2PoleCount : boardData.Chassis1PoleCount}
                                        remaining={this.getRemainingPoleCount(this.state.selectedChassisIndex)}
                                        configured={this.getConfiguredPoleCount(this.state.selectedChassisIndex)}
                                        powerLossPercentage={this.state.selectedChassisIndex === 2 ?
                                            (this.state.board.PowerLossChassis2 > 0 && this.state.board.MaxChassisPowerLoss > 0 ?
                                                ((this.state.board.PowerLossChassis2 / this.state.board.MaxChassisPowerLoss) * 100) : 0
                                            )
                                            :
                                            (this.state.board.PowerLossChassis1 > 0 && this.state.board.MaxChassisPowerLoss > 0 ?
                                                ((this.state.board.PowerLossChassis1 / this.state.board.MaxChassisPowerLoss) * 100) : 0
                                            )
                                        }
                                        powerLossCheckSuccess={this.state.selectedChassisIndex === 2 ? this.state.board.Chassis2PowerLossCheckSuccess : this.state.board.Chassis1PowerLossCheckSuccess}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LooseItems
                    project={this.state.project}
                    board={this.state.board}
                    isOpen={this.state.isLooseItemsPanelOpen}
                    partsList={this.state.miscParts}
                    selected={this.state.board.ProjectBoardLooseSupplyItemCollection ? this.state.board.ProjectBoardLooseSupplyItemCollection : []}
                    isLoading={this.state.isLoading.form}
                    updateCallback={this.updateSelectedMiscParts}
                    commercialAllPartsAvailable={this.state.commercialAllPartsAvailable}
                />

                {
                    this.state.isConfiguringBoard &&
                    <BoardDetails
                        board={this.state.boardToConfigure}
                        boardOptions={this.state.boardOptions}
                        boardOptionData={this.state.boardOptionData}
                        closeCallback={this.stopConfiguringBoard}
                        onUpdateCallback={(updatedBoardData) => {
                            this.setState({ board: updatedBoardData })
                        }}
                        projectID={this.state.projectID}
                    />
                }
            </div>

        )
    }
}

export default withRouter(ConfigChassis)